module.exports = __webpack_public_path__ + "img/4med-chart-4.e5cfd5dd.png";